import * as React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Button, Menu, MenuItem, Icon, IconButton } from '@material-ui/core'
import { Link } from 'react-router-dom'

const mainPages = [
  { id: 'why', name: 'Why', path: '/about/why' },
  { id: 'how', name: 'How', path: '/about/how' },
  { id: 'what', name: 'What', path: '/about/what' },
  { id: 'proof', name: 'Proof', path: '/about/proof' },
  { id: 'hitl', name: 'Our Humans', path: '/about/hitl' },
  { id: 'roadmap', name: 'Roadmap', path: '/about/roadmap' }
]

const morePages = [
  { id: 'flipped-classroom', name: 'Flipped Classroom', path: '/about/flipped-classroom' },
  { id: 'process-versioning', name: 'Process Versioning', path: '/about/process-versioning' },
  { id: 'ai-factory', name: 'AI Factory', path: '/about/ai-factory' },
  { id: 'the-model', name: 'The Model', path: '/about/the-model' },
  { id: 'delivery', name: 'Delivery', path: '/about/delivery' },
  { id: 'personas', name: 'Personas', path: '/about/personas' },
  { id: 'comparison', name: 'Comparison', path: '/about/comparison' },
  { id: 'business-mining', name: 'Business Mining', path: '/about/business-mining' },
  { id: 'terminology', name: 'Terminology', path: '/about/terminology' },
  { id: 'architectural-objects', name: 'Architectural Objects', path: '/about/architectural-objects' },
  { id: 'data-objects', name: 'Data Objects', path: '/about/data-objects' },
  { id: 'use-cases', name: 'Use Cases', path: '/about/use-cases' },
  { id: 'data-model', name: 'Data Model', path: '/about/data-model' }
]

interface PageNavigationProps {
  classes: any
  currentPage: string
  tubeColor?: string
}

const PageNavigation: React.FC<PageNavigationProps> = ({ classes, currentPage, tubeColor }) => {
  const primaryColor = tubeColor || '#1976d2'
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const isMorePageActive = morePages.some((page) => page.id === currentPage)

  return (
    <div className={classes.navContainer}>
      {mainPages.map((page) => (
        <Button
          key={page.id}
          component={Link}
          to={page.path}
          className={page.id === currentPage ? classes.navButtonActive : classes.navButtonInactive}
          style={page.id === currentPage ? { backgroundColor: primaryColor } : undefined}
        >
          {page.name}
        </Button>
      ))}

      <Button
        onClick={handleClick}
        className={isMorePageActive ? classes.dropdownButtonActive : classes.dropdownButton}
        style={isMorePageActive ? { backgroundColor: primaryColor } : undefined}
      >
        More
        <Icon className={classes.dropdownIcon}>{open ? 'expand_less' : 'expand_more'}</Icon>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        getContentAnchorEl={null}
        PaperProps={{
          style: {
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
            marginTop: '8px'
          }
        }}
      >
        {morePages.map((page) => (
          <MenuItem
            key={page.id}
            component={Link}
            to={page.path}
            onClick={handleClose}
            className={page.id === currentPage ? classes.menuItemActive : classes.menuItem}
            style={page.id === currentPage ? { color: primaryColor } : undefined}
          >
            {page.name}
          </MenuItem>
        ))}
      </Menu>

      <IconButton component={Link} to="/home" className={classes.closeButton} aria-label="Close">
        <Icon style={{ fontSize: '20px' }}>close</Icon>
      </IconButton>
    </div>
  )
}

const styles = () => ({
  navContainer: {
    display: 'flex',
    gap: '6px',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    padding: '6px 8px',
    borderRadius: '28px'
  },
  navButtonActive: {
    textTransform: 'none' as const,
    fontSize: '14px',
    padding: '8px 20px',
    borderRadius: '22px',
    minWidth: 'auto',
    fontWeight: 600,
    backgroundColor: '#1976d2',
    color: '#fff',
    textDecoration: 'none',
    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#1565c0',
      boxShadow: '0 4px 12px rgba(25, 118, 210, 0.4)'
    }
  },
  navButtonInactive: {
    textTransform: 'none' as const,
    fontSize: '14px',
    padding: '8px 20px',
    borderRadius: '22px',
    minWidth: 'auto',
    fontWeight: 500,
    backgroundColor: 'transparent',
    color: '#555',
    textDecoration: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.06)',
      color: '#1976d2'
    }
  },
  dropdownButton: {
    textTransform: 'none' as const,
    fontSize: '14px',
    padding: '8px 14px 8px 20px',
    borderRadius: '22px',
    minWidth: 'auto',
    fontWeight: 500,
    backgroundColor: 'transparent',
    color: '#555',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.06)',
      color: '#1976d2'
    }
  },
  dropdownButtonActive: {
    textTransform: 'none' as const,
    fontSize: '14px',
    padding: '8px 14px 8px 20px',
    borderRadius: '22px',
    minWidth: 'auto',
    fontWeight: 600,
    backgroundColor: '#1976d2',
    color: '#fff',
    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#1565c0',
      boxShadow: '0 4px 12px rgba(25, 118, 210, 0.4)'
    }
  },
  dropdownIcon: {
    fontSize: '20px',
    marginLeft: '4px'
  },
  menuItem: {
    fontSize: '14px',
    padding: '12px 24px',
    minWidth: '180px',
    transition: 'all 0.15s ease',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  menuItemActive: {
    fontSize: '14px',
    padding: '12px 24px',
    minWidth: '180px',
    backgroundColor: '#e3f2fd',
    color: '#1976d2',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#bbdefb'
    }
  },
  closeButton: {
    width: '36px',
    height: '36px',
    marginLeft: '4px',
    color: '#555',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)'
    }
  }
})

export default withStyles(styles)(PageNavigation)
